module.exports = __webpack_public_path__ + "static/img/FQA_ZH_1.1a17828.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/FQA_ZH_1.png
// module id = Xh7W
// module chunks = 4